/* unplugin-vue-components disabled */import { render } from "./IopEvent.vue?vue&type=template&id=09c1a266&scoped=true"
import script from "./IopEvent.vue?vue&type=script&lang=js"
export * from "./IopEvent.vue?vue&type=script&lang=js"

import "./IopEvent.vue?vue&type=style&index=0&id=09c1a266&lang=scss"
import "./IopEvent.vue?vue&type=style&index=1&id=09c1a266&scoped=true&lang=scss"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c1a266"]])

export default __exports__